<template>
    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->
    <!-- 도움말 -->
    <!-- ------------------------------------------------------------------------------------------------------------------------------------ -->

    <div v-if="isMobile">
      <div v-show="isShow" :style="{ 'width': item.width, 'background-color': 'white', 'border': '3px solid #808080', 'position': 'absolute', 'z-index' : '10000'}"
        >
        <i-bar ref="drag_handle" :title="`${this.item.titl}`" class="window-header pop_tit">
            <i-bar-btn @click="hide()">닫기</i-bar-btn>
        </i-bar>
        <div class="cont" style="padding: 10px; line-height: 2.2;">
          <div v-html="this.item.txt1" :style="{'height': item.height, 'overflow-y': 'auto', 'font-size':'18px'}"/>
          <label style="cursor: pointer;" class="right"><input type="checkbox" @change="doclose"/> 오늘은 그만보기</label>
        </div>
      </div>
    </div>

    <div v-else >
      <div v-show="isShow" :style="{ 'width': item.width, 'background-color': 'white', 'border': '3px solid #808080', 'position': 'absolute', 'z-index' : '10000'}"
        v-draggable="draggableOpts">
        <i-bar ref="drag_handle" :title="`${this.item.titl}`" class="window-header pop_tit">
            <i-bar-btn @click="hide()">닫기</i-bar-btn>
        </i-bar>
        <div class="cont" style="padding: 10px; line-height: 2.2;">
          <div v-html="this.item.txt1" :style="{'height': item.height, 'overflow-y': 'auto', 'font-size':'18px'}"/>
          <label style="cursor: pointer;" class="right"><input type="checkbox" @change="doclose"/> 오늘은 그만보기</label>
        </div>
      </div>
    </div>
</template>

<script>
import { Draggable } from 'draggable-vue-directive' // https://github.com/IsraelZablianov/draggable-vue-directive
export default {
  directives: {
    Draggable,
  },
  data() {
    return {
      isShow: false,
      draggableOpts: {
        handle: undefined, // mounted() 할때 지정할 예정
        resetInitialPos: true,
        initialPosition: { left: 147, top: 59 },
      },
      item: {},
      isMobile : false
    }
  },
  created() {
    this.isMobile = this.$mq == 'mobile' ? true : false
  },
  mounted() {
    this.isMobile ? this.draggableOpts.handle = this.$refs.drag_handle : '' // 모바일이 아닐 경우에만 드래그 세팅
  },
  methods: {
    show(item) {
      this.isShow = true
      console.log(item);
      this.item = item
      this.item.width = this.$mq == 'mobile' ? 'auto' : this.item.width // 모바일에서 width를 auto로 안해주면 닫기 버튼을 누를 수 없음. 단, 내용이 텍스트만 있는 경우

    },
    hide() { this.isShow = false },
    doclose(){
      this.$cookie.set('todayyn_' + this.item.seq, 1, 1)
      this.hide()
    },
  },
}
</script>